export const IS_SHOW_SOURCES_REVIEW_BANNER_STORAGE_KEY = 'is-show-sources-review-banner';
